export class AloftObject {
    /**
     * An equivalence relation. Should be reflexive, transitive, symmetric, and
     * all that good stuff.
     */
    equals(that) {
        return this.compare(that) === 0;
    }
    gt(that) {
        return this.compare(that) > 0;
    }
    lt(that) {
        return this.compare(that) < 0;
    }
    ge(that) {
        return this.compare(that) >= 0;
    }
    le(that) {
        return this.compare(that) <= 0;
    }
}
//# sourceMappingURL=AloftObject.js.map